import React from 'react';
import withIcon from '../utilities/withIcon';

const IconTemplate = () => {
  return (
    <g>
      <path d="M14.1.2H1.9C1.4.2 1 .5 1 1v14c0 .5.4.8.8.8h12.3c.5 0 .8-.4.8-.8V1c0-.5-.3-.8-.8-.8zm-.4 1.2v2.5H2.3V1.4h11.4zM2.3 9V5.3h5.6V9H2.3zm0 1.4h5.6v4.2H2.3v-4.2zm6.9 4.2V5.3h4.5v9.3H9.2z" />
    </g>
  );
};

export default withIcon(IconTemplate);
